import React from 'react';

import styled from 'styled-components';

const Logo = props => (
  <StyledLogo viewBox="0 0 276.2 209.76" {...props}>
    <defs>
      <style>
        {
          '.prefix__cls-1{fill:none}.prefix__cls-1,.prefix__cls-3{stroke:#000;stroke-miterlimit:10}.prefix__cls-2{fill:#8cbdc0}.prefix__cls-3{fill:#90d4d8}'
        }
      </style>
    </defs>
    <title>{'crown'}</title>
    <g id="prefix__Layer_2" data-name="Layer 2">
      <path
        className="prefix__cls-2"
        d="M263.5 413s1.68 13.64 14 30 22 26.24 29.61 32.75c7.85 6.68 14.17 11.82 18.92 12.91s6.33-1.34-.33-5.67c-8.95-5.82-23.06-19.25-23.06-19.25s15.08-28.92 15.64-33.83 5.59 17.46 11.73 26.19 14 16.92 15.09 18.55-3.35 4.37-2.8 6.55 3.36 2.19 3.36 2.19a116.7 116.7 0 0014-14.19c6.15-7.64 16.08-20.54 18.44-26.74s3.94-5.3 3.94-5.3-3.38 37.49-5.62 43.5-5.58 15.82-18.43 19.64-35.76 9.82-52.52 11.46-41.9 2.73-41.9 2.73-25.14-1.09-41.9-2.73-39.67-7.64-52.52-11.46-16.2-13.64-18.43-19.64c-2.08-5.59-5-40.3-5.34-45.1.16.94.85 3.11 3.66 6.9 3.94 5.3 12.29 19.1 18.44 26.74a116.7 116.7 0 0014 14.19s2.8 0 3.36-2.19-3.92-4.91-2.8-6.55 8.94-9.82 15.09-18.55 11.17-31.1 11.73-26.19 15.64 33.83 15.64 33.83-12.85 14-22.06 18.92c-6.38 3.4-4 6.66 1.67 4 4.41-2.07 7.54-4.91 15.92-10.91s17.32-16.38 29.61-32.75 13.86-30 13.86-30zM145.26 435v.5a1.9 1.9 0 010-.5z"
        transform="translate(-126.56 -305.24)"
      />
      <path
        className="prefix__cls-1"
        d="M145.31 435.57c.38 4.8 3.26 39.51 5.34 45.1 2.23 6 5.58 15.82 18.43 19.64s35.76 9.82 52.52 11.46 41.9 2.73 41.9 2.73M145.26 435v.5"
        transform="translate(-126.56 -305.24)"
      />
      <path
        className="prefix__cls-1"
        d="M263.5 413s-1.68 13.64-14 30-21.23 26.74-29.61 32.75-11.48 8.85-15.89 10.92c-5.67 2.66-8.05-.6-1.67-4 9.21-4.91 22.06-18.92 22.06-18.92s-15.08-28.92-15.64-33.83-5.59 17.46-11.73 26.19-14 16.92-15.09 18.55 3.35 4.37 2.8 6.55-3.36 2.19-3.36 2.19a116.7 116.7 0 01-14-14.19c-6.15-7.64-14.5-21.44-18.44-26.74-2.81-3.79-3.5-6-3.66-6.9a.43.43 0 000-.05 1.9 1.9 0 010-.5M263.5 416v-3s1.68 13.64 14 30 22 26.24 29.61 32.75c7.85 6.68 14.17 11.82 18.92 12.91s6.33-1.34-.33-5.67c-8.95-5.82-23.06-19.25-23.06-19.25s15.08-28.92 15.64-33.83 5.59 17.46 11.73 26.19 14 16.92 15.09 18.55-3.35 4.37-2.8 6.55 3.36 2.19 3.36 2.19a116.7 116.7 0 0014-14.19c6.15-7.64 16.08-20.54 18.44-26.74s3.94-5.3 3.94-5.3-3.38 37.49-5.62 43.5-5.58 15.82-18.43 19.64-35.76 9.82-52.52 11.46-41.9 2.73-41.9 2.73"
        transform="translate(-126.56 -305.24)"
      />
    </g>
    <g id="prefix__Layer_3" data-name="Layer 3">
      <path
        className="prefix__cls-3"
        d="M286 333.24c0 15.19-22.5 59.76-22.5 59.76S241 348.43 241 333.24s10.07-27.5 22.5-27.5 22.5 12.32 22.5 27.5z"
        transform="translate(-126.56 -305.24)"
      />
      <path
        d="M225 369.8c0 10.53-15.59 41.42-15.59 41.42s-15.59-30.89-15.59-41.42 7-19.06 15.59-19.06S225 359.27 225 369.8z"
        transform="translate(-126.56 -305.24)"
        fill="#90cfd3"
        stroke="#000"
        strokeMiterlimit={10}
      />
      <path
        className="prefix__cls-3"
        d="M334.5 369.8c0 10.53-15.59 41.42-15.59 41.42s-15.59-30.89-15.59-41.42 7-19.06 15.59-19.06 15.59 8.53 15.59 19.06z"
        transform="translate(-126.56 -305.24)"
      />
      <path
        d="M163.45 356.73c0 12.28-18.19 48.32-18.19 48.32s-18.19-36-18.19-48.32 8.15-22.24 18.19-22.24 18.19 9.96 18.19 22.24z"
        transform="translate(-126.56 -305.24)"
        fill="#8fcace"
        stroke="#000"
        strokeMiterlimit={10}
      />
      <path
        className="prefix__cls-3"
        d="M402.26 356.73c0 12.28-18.19 48.32-18.19 48.32s-18.19-36-18.19-48.32 8.12-22.23 18.18-22.23 18.2 9.95 18.2 22.23z"
        transform="translate(-126.56 -305.24)"
      />
    </g>
  </StyledLogo>
);

export default Logo;

const StyledLogo = styled.svg`
  height: 50px;
  width: 50px;
  float: right;
  margin: auto 0;
`;
